const EMAIL_VALIDATOR = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const PASSWORD_VALIDATOR = /\w*[A-Z]+\w*/;

export {EMAIL_VALIDATOR, PASSWORD_VALIDATOR};

